export default "assets/images/tripadvisor_bg-e97b216c.png";